import React, { act } from "react";
import Accordion from "react-bootstrap/Accordion";
import parse from "html-react-parser";

const AccordionItem = ({
  data,
  scrollKey,
  accordionName,
  scrollRef,
  activeKey,
}) => {
  return (
    <div>
      <Accordion
        ref={(el) => (scrollRef.current[scrollKey] = el)}
        defaultActiveKey={"391"}
      >
        {data?.map((item, index) => 
        (
          <Accordion.Item
            id={item.id === 391 ? "developer-mode" : ""}
            eventKey={`${item?.id}`}
            key={`${item?.id}`}
          >
            <Accordion.Header className="accordion-header-custom">
              {item.Title}
            </Accordion.Header>
            <Accordion.Body>
              {typeof item.Description === 'string' ? parse(item.Description) : item.Description}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default AccordionItem;
